export function shouldShowCardComplete(studentActivities) {
  // if at least one activity is complete, show the card as complete
  return studentActivities?.some(activity => activity?.isComplete) || false
}
